import { InjectionToken } from "@angular/core";
import type * as Bootstrap from "bootstrap";

export type BootstrapWindow = Window & {
    bootstrap: typeof Bootstrap;
};

export const BOOTSTRAP_TOKEN = new InjectionToken("BootstrapToken", {
    providedIn: "root",
    factory: (): typeof Bootstrap => (window as unknown as BootstrapWindow).bootstrap
});
